import React from 'react';

import './_game-record.scss';


const GameRecord = (props) =>
  (<div className="col-lg-6 records">
    <div className="row mx-lg-2 mb-5 mb-lg-2 clippedbox--color-dark-small text-center">
      <h2 className="heading--gray my-4 col-12">{props.title}</h2>
      <div className="col-6 px-0 mb-1">
        <p className="heading--gray">Team</p>
      </div>
      <div className="col-2 px-0">
        <p className="heading--gray">Year</p>
      </div>
      <div className=" col-2 px-0">
        <p className="heading--gray">Week</p>
      </div>
      <div className=" col-2 px-0">
        <p className="heading--gray">{props.label}</p>
      </div>
        {props.data.map((item, i) =>(
          <React.Fragment key={i}>
            <div className="col-12 alt">
              <div className="row flex-center">
            <div className="col-6 flex-center pr-0">
              <p  className="rank-number">{i + 1}</p>
                  <img alt="team-logo" src={item.image} className="image" onError={function (ev) { 
                    ev.target.src = "https://fantasy-franchise.com/img/DEF.png";
                    }} />
              <p className="name">{item.name}</p>
            </div>
            <div className="col-2 px-0 text-center">
              <p>{item.year}</p>
            </div>
            <div className="col-2 text-center">
              <p>{item.week}</p>
            </div>
            <div className= "col-2 px-0 text-center">
              <p>{item.score}</p>
            </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>);

export default GameRecord;
